/** 主应用 standbyGuard 写入；Standby 页签不读 HID */
export function isDeviceSessionStandbyRuntime(): boolean {
  if (typeof window === "undefined") return false;
  return !!window.__eweadn_deviceSessionStandby;
}

declare global {
  interface Window {
    __eweadn_deviceSessionStandby?: boolean;
  }
}
